// extracted by mini-css-extract-plugin
export default {"comp":"Icon_comp__VEpWl"};